function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00933 4.36C8.00933 4.36 9.44067 1.714 10.326 0L16 5.674C14.278 6.55467 11.6293 7.98 11.6293 7.98L8.00933 4.36ZM2.33133 8.642C2.33133 8.642 1.43867 12.1447 0 14.378L0.551333 14.9287L3.196 12.284C3.428 12.052 3.57533 11.75 3.61533 11.4253C3.638 11.2453 3.71733 11.0707 3.856 10.932C4.188 10.6 4.72667 10.6 5.058 10.932C5.39 11.2647 5.39 11.802 5.058 12.134C4.91933 12.2733 4.74533 12.3527 4.56467 12.3747C4.23933 12.4153 3.938 12.562 3.706 12.7947L1.06133 15.44L1.612 16C3.82133 14.578 7.348 13.6593 7.348 13.6593L10.1893 8.43467L7.55533 5.80067L2.33133 8.642Z",
  fill: "current"
});

var SvgIconmonstrPen141 = function SvgIconmonstrPen141(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconmonstrPen141, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconmonstr-pen-14 1.3e35111e.svg";
export { ForwardRef as ReactComponent };